module.exports = __webpack_public_path__ + "img/49375.715633ee.jpg";